/** Shared 16-viewBox stroke icons — one drawing style every control inherits. */

function Stroke({ d, className = 'h-3.5 w-3.5' }: { d: string; className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={d} />
    </svg>
  )
}

export function PlusIcon({ className }: { className?: string }) {
  return <Stroke d="M8 2.5v11M2.5 8h11" className={className} />
}

export function XIcon({ className }: { className?: string }) {
  return <Stroke d="M4 4l8 8M12 4l-8 8" className={className} />
}

export function SearchIcon({ className }: { className?: string }) {
  return <Stroke d="M7 12.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM11 11l3.5 3.5" className={className} />
}

export function CalendarIcon({ className }: { className?: string }) {
  return <Stroke d="M3 6.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6ZM3 8h10M5.5 3.5v2M10.5 3.5v2" className={className} />
}

export function CopyIcon({ className }: { className?: string }) {
  return <Stroke d="M6 6V4.5a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1V9a1 1 0 0 1-1 1H10M3.5 6.5h5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z" className={className} />
}

export function EyeIcon({ className }: { className?: string }) {
  return <Stroke d="M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8ZM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" className={className} />
}

export function EyeOffIcon({ className }: { className?: string }) {
  return <Stroke d="M6.2 6.2A2 2 0 0 0 8 10a2 2 0 0 0 1.8-1.1M3 3l10 10M5.2 4.7A8 8 0 0 1 8 3.5c4 0 6.5 4.5 6.5 4.5a13 13 0 0 1-2 2.5M3.4 5.6A13 13 0 0 0 1.5 8S4 12.5 8 12.5c.6 0 1.2-.1 1.7-.3" className={className} />
}

export function MessageIcon({ className }: { className?: string }) {
  return <Stroke d="M2.5 4.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H6l-3 2.5V10.5a1 1 0 0 1-.5-.87V4.5Z" className={className} />
}

export function BellIcon({ className }: { className?: string }) {
  return <Stroke d="M5 7a3 3 0 0 1 6 0c0 2.5 1 3.5 1 3.5H4S5 9.5 5 7ZM6.8 12.5a1.3 1.3 0 0 0 2.4 0" className={className} />
}

/** Clapperboard — auditions. */
export function FilmIcon({ className }: { className?: string }) {
  return <Stroke d="M2.5 6.5h11v6a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-6ZM2.7 6.5 4 3.7l2.2 1.2M6 6.4 7.3 3.6l2.2 1.2M9.3 6.3 10.6 3.5l2.2 1.2" className={className} />
}

export function DocIcon({ className }: { className?: string }) {
  return <Stroke d="M4.5 2.5h4l3 3v8a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1ZM8.5 2.5v3h3M6 8.5h4M6 11h4" className={className} />
}

/** Image / photo+video hub. */
export function ImageIcon({ className }: { className?: string }) {
  return <Stroke d="M2.5 4.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-7ZM2.7 11l3.3-3 2.5 2.2 2-1.7 2.8 2.5M6 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" className={className} />
}

export function PlayIcon({ className }: { className?: string }) {
  return <Stroke d="M5.5 3.8v8.4l7-4.2-7-4.2Z" className={className} />
}

/** A check in a circle: the quick check of a profile's details. */
export function CheckCircleIcon({ className }: { className?: string }) {
  return <Stroke d="M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM5.4 8.2l1.8 1.8 3.4-3.6" className={className} />
}

/** An ID card: a work permit. */
export function PermitIcon({ className }: { className?: string }) {
  return <Stroke d="M2.5 4.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-7ZM5.8 8a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6ZM4 10.8c.4-.9 1-1.3 1.8-1.3s1.4.4 1.8 1.3M9.3 6.5h2.5M9.3 9h2.5" className={className} />
}

/** A person: someone's details changed. */
export function PersonIcon({ className }: { className?: string }) {
  return <Stroke d="M8 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3 13.5c.6-2.3 2.6-3.8 5-3.8s4.4 1.5 5 3.8" className={className} />
}

/** A short list: a digest of what happened. */
export function ListIcon({ className }: { className?: string }) {
  return <Stroke d="M6 4.5h7.5M6 8h7.5M6 11.5h7.5M2.8 4.5h.4M2.8 8h.4M2.8 11.5h.4" className={className} />
}

/** The four-color Google "G" — brand mark, not a stroke icon (used by sign-in & calendar sync). */
export function GoogleGlyph({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <path fill="#4285F4" d="M23.5 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.1 3.57-5.18 3.57-8.81z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3c-1.07.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.11-6.72-4.95H1.27v3.1A12 12 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.28 14.29a7.2 7.2 0 0 1 0-4.58v-3.1H1.27a12 12 0 0 0 0 10.78l4.01-3.1z" />
      <path fill="#EA4335" d="M12 4.76c1.76 0 3.34.6 4.59 1.8l3.44-3.45A11.98 11.98 0 0 0 1.27 6.6l4.01 3.1C6.23 6.88 8.88 4.76 12 4.76z" />
    </svg>
  )
}
